import * as React from "react";
import Tile from "./elements/Tile";
import Top from "./elements/Top";
import Bottom from "./elements/Bottom";
import { Title, Subtitle, Meta } from "./elements/Typo";
import Icon from "../../elements/Icon";
import { ActivityType, ActivityTypeDisplayMap } from "./types";
import ActivityTypeTag from "./elements/ActivityTypeTag";

type Props = {
  style?: React.CSSProperties;
  className?: string;
  imageSrc: string;
  title: string;
  supplier: string;
  type: ActivityType;
  typeMap: ActivityTypeDisplayMap;
  onClick?: () => void;
  texts: {
    sharedActivity: string;
  };
  isShared?: boolean;
  draggable?: boolean;
  topRight?: React.ReactNode;
  dragHandlers: any;
  [key: string]: any;
};

function AdminActivityTile(
  {
    style,
    className,
    imageSrc,
    title,
    supplier,
    type,
    typeMap,
    onClick,
    texts,
    isShared,
    draggable,
    topRight,
    dragHandlers,
    ...rest
  }: Props,
  ref: any
) {
  return (
    <Tile
      ref={ref}
      style={style}
      className={className}
      onClick={onClick}
      draggable={draggable}
      {...dragHandlers}
      {...rest}
    >
      <Top imageSrc={imageSrc}>
        <ActivityTypeTag {...typeMap[type]} />
      </Top>
      <Bottom
        topLeft={
          <>
            <Title>{title}</Title>
            <Subtitle>{supplier}</Subtitle>
            {isShared && (
              <div
                style={{ display: "flex", alignItems: "center", marginTop: 4 }}
              >
                <Icon
                  name="share"
                  c={["grey", 6]}
                  size={12}
                  style={{ marginRight: 4 }}
                />
                <Meta>{texts.sharedActivity}</Meta>
              </div>
            )}
          </>
        }
        topRight={topRight}
      />
    </Tile>
  );
}

export default React.memo(React.forwardRef(AdminActivityTile), (prev, next) => {
  if (prev.title !== next.title) {
    return false;
  }

  if (prev.supplier !== next.supplier) {
    return false;
  }

  if (prev.imageSrc !== next.imageSrc) {
    return false;
  }

  return true;
});
